import useBrandingStore from "stores/useBrandingStore";
import {
  resolveDocumentBranding,
  resolveLoginBackgroundColor,
  resolveLoginLogoUrl,
  resolvePostLoginBranding,
  resolvePreLoginBranding,
} from "utils/branding/brandingResolver";

export const useResolvedPreLoginBranding = () => {
  const payload = useBrandingStore((s) => s.preLogin);
  return resolvePreLoginBranding(payload);
};

export const useResolvedPostLoginBranding = () => {
  const payload = useBrandingStore((s) => s.postLogin);
  return resolvePostLoginBranding(payload);
};

export const useResolvedLoginBranding = () => {
  const payload = useBrandingStore((s) => s.preLogin);
  return {
    logoUrl: resolveLoginLogoUrl(payload),
    backgroundColor: resolveLoginBackgroundColor(payload),
  };
};

export const useResolvedDocumentBranding = () => {
  return resolveDocumentBranding();
};
